import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const Layout = () => (
  <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, duration: 1.1 }}>
    <ScrollToTop />
    <Navbar />
    <main className="min-h-screen">
      <Outlet />
    </main>
    <Footer />
    <Toaster position="bottom-right" theme="dark" richColors />
  </ReactLenis>
);
